import type { AppointmentTypeStore } from '@fitness-force/models';

export const APPOINTMENT_TYPE_STATE:AppointmentTypeStore =   {
    appointmentTypes:[]
} 